var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOwner = function SvgOwner(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M7.012 10.083c.91 0 1.785-.373 2.429-1.037a3.6 3.6 0 0 0 1.006-2.504c0-.94-.362-1.84-1.006-2.505A3.38 3.38 0 0 0 7.01 3c-.91 0-1.784.373-2.428 1.037a3.6 3.6 0 0 0-1.007 2.505c0 .939.362 1.84 1.007 2.504a3.38 3.38 0 0 0 2.429 1.037m-1.227 1.329C3.142 11.412 1 13.619 1 16.345a.81.81 0 0 0 .797.822h10.43a.79.79 0 0 0 .649-.346l-2.662-2.745a2.23 2.23 0 0 1-.626-1.552v-.913c-.426-.13-.88-.2-1.35-.2zm5.52-2.214a.87.87 0 0 0-.858.885v2.289c0 .47.18.921.502 1.253l2.882 2.969a1.264 1.264 0 0 0 1.823 0l1.97-2.031a1.36 1.36 0 0 0 0-1.879L14.74 9.715a1.7 1.7 0 0 0-1.216-.517zm.645 2.214c0-.177.068-.346.189-.47a.634.634 0 0 1 .91 0 .674.674 0 0 1 0 .939.634.634 0 0 1-.91 0 .67.67 0 0 1-.189-.47"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOwner);
export default ForwardRef;